<div *ngIf="parts > 1" class="error-messages">Message will be sent in {{parts}} parts</div>
